/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { deliveryCourierLocationSchema } from "./deliveryCourierLocationSchema.ts";

export const deliveryOrdersCourierRetrievePathOrderIdSchema = z.uuid();

export const deliveryOrdersCourierRetrieveStatus200Schema = deliveryCourierLocationSchema;

export const deliveryOrdersCourierRetrieveStatus204Schema = z.any();

export const deliveryOrdersCourierRetrieveResponseSchema = z.union([
	deliveryOrdersCourierRetrieveStatus200Schema,
	deliveryOrdersCourierRetrieveStatus204Schema,
]);
